import { connect } from 'react-redux';
import ShareComponent from '../components/ShareComponent';

const mapStateToProps = (state) => {
    const aovivoBar = state.aovivoBar;
    const music = aovivoBar.MediaPlayer.isLive === 'otherMedia'
        ? aovivoBar.NowPlaying.music
        : aovivoBar.NowPlaying.musicLive;

    return {
        artist: music.artist,
        song: music.song,
        metaType: music.metaType,
        isMobile: state.clientInfo.isMobile,
    };
};

export default connect(mapStateToProps, {})(ShareComponent);
